<!--
/*******************************************************************************
*@ 컴포넌트명   : cbmnetManagePayees.vue
*@ 컴포넌트설명 : 미얀마 타행 자주쓰는계좌등록
*@ 사용전문     : RBF0408W41 - 현지은행목록조회
                 RBF0600C60 - 입출금계좌등록
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 2022.08.18   이가영   미얀마 CBM-NET2 수취인 글자수 제한 140자로 변경
** 2022.12.01   최지영   미얀마 CBM-NET2 입금부점코드 추가
********************************************************************************/
-->
<template>
  <div class="scroll">
    <article class="contents">
      <div class="form">
        <div class="form-row">
          <select-box ref="ovsesSendBnkRefno" :value.sync="ovsesSendBnkRefno" :option-list="bankList" label-i18n="MPRS-02-02-09-02" @selected="selected" required />
        </div>
        <div class="form-row">
          <input-text ref="inquryAcno" id="inquryAcno" :value.sync="inquryAcno" labelI18n="MPRS-02-02-09-04" placeholder="MPRS-02-02-09-04" required :maxByte="20" alphaNumOnly />
          <div class="info info-etc" v-html="$t('MPRS-02-02-09-12', { 1: cncycd })"></div>
        </div>
        <div class="form-row" v-if="showLcalBnkBrnEngName == true">
          <div class="item-tit">
            {{ /*지점명*/ $t("MPRS-02-02-10-06") }}
            <sup class="point">*</sup>
          </div>
          <div class="item-desc">
            <div class="form-text-field search">
              <div class="input-text-field">
                <input type="text" id="lcalBnkBrnEngName" class="form-control" placeholder disabled :value.sync="lcalBnkBrnEngName" />
                <button class="btn sm inline search" @click="popupOpen">{{ /*조회*/ $t("MPRS-02-02-13-06") }}</button>
              </div>
            </div>
            <div class="validate" v-if="lcalBnkBrnEngNameVal == true && lcalBnkBrnEngName == ''">{{ /*필수 항목입니다.*/ $t("validations.required") }}</div>
          </div>
        </div>
        <div class="form-row">
          <input-text
            v-if="usePage == 'cbmnet'"
            ref="inquryDpstrName"
            id="inquryDpstrName"
            :value.sync="inquryDpstrName"
            labelI18n="MPRS-02-02-19-05"
            placeholder="MPRS-02-02-19-06"
            required
            :maxByte="140"
            engCase3
          />
          <input-text
            v-else
            ref="inquryDpstrName"
            id="inquryDpstrName"
            :value.sync="inquryDpstrName"
            labelI18n="MPRS-02-02-19-05"
            placeholder="MPRS-02-02-19-06"
            required
            :maxByte="70"
            localeCase3
          />
          <!-- <div class="info info-etc" v-if="usePage == 'manage'">※ {{ $t("MPRS-02-02-10-14") }}</div> -->
        </div>
        <div class="form-row" v-if="usePage == 'manage'">
          <input-text ref="inquryAcnAls" id="inquryAcnAls" :value.sync="inquryAcnAls" labelI18n="MPRS-02-02-19-07" placeholder="MPRS-02-02-19-08" required :maxByte="40" engCase6 />
          <!-- <div class="info info-etc">※ {{ $t("MPRS-02-02-10-15") }}</div> -->
        </div>
      </div>

      <popup :opened.sync="popupShow" :use-footer="false" :allScroll="true" title="MPRS-02-02-13-01" @cancel="popupClose">
        <template #content>
          <div class="form-search top">
            <div class="form-row">
              <div class="item-tit">
                {{ bnkEngName }} ({{ ovsesSendBnkRefno }})
                <i class="icon icon-fillter" @click="fillter = !fillter" />
              </div>
              <div class="item-desc" v-if="fillter">
                <radio-box id="searchBox" ref="searchBox" :data-list="radioList" :value.sync="checkedRadioValue" :is-horizontal="true" />
                <input-text id="searchWord" :value.sync="searchWord" placeholder="MPAY-02-01-10-07" toLowerCase :maxByte="40" />
              </div>
            </div>
            <div class="form-row" v-if="fillter">
              <button class="btn lg normal" @click="search">{{ /*조회*/ $t("MPRS-02-02-13-06") }}</button>
            </div>
          </div>
          <common-grid2 ref="commonGrid2" :list="popupRBF0408W41.response.grid" :totalCss="['total-count', 'no-border']" :scroll-event="true" :tagType="'div'" v-show="showGrid">
            <template v-slot:list="data">
              <div class="box-white -type4">
                <div class="header" @click="popupClose(data.row)">
                  <div class="title">
                    {{ data.row.cctBrncdNo }}
                    <i class="icon icon-arrow-m-right" />
                  </div>
                </div>
                <div class="content">
                  <div class="item">{{ /*지점*/ $t("MPRS-02-02-18-03") }} : {{ data.row.brncoBrnName }}</div>
                  <div class="item">{{ /*주소*/ $t("MPRS-02-02-14-03") }} : {{ data.row.lcalBnkAddrCtnt1 }}</div>
                </div>
              </div>
            </template>
          </common-grid2>
        </template>
      </popup>
      <action-sheet :opened.sync="openSheet" :actionHeader="true" :actionFooter="true" :useTopBorder="true" title="MPRS-02-02-11-01" class="action-sheet">
        <template #content>
          <div class="form-confirm">
            <div class="form-row">
              <div class="item-tit">{{ /*입금계좌번호*/ $t("MPAY-02-01-26-08") }}</div>
              <div class="item-desc">
                <div class="form-text-field">{{ inquryAcno }}</div>
              </div>
            </div>
            <div class="form-row">
              <div class="item-tit">{{ /*은행명*/ $t("MPRS-02-02-02-05") }}</div>
              <div class="item-desc">
                <div class="form-text-field">{{ bnkEngName }}</div>
              </div>
            </div>
            <div class="form-row">
              <div class="item-tit">{{ /*지점명*/ $t("MPRS-02-02-02-06") }}</div>
              <div class="item-desc">
                <div class="form-text-field">{{ lcalBnkBrnEngName }}</div>
              </div>
            </div>
          </div>
          <strong class="info-question">{{ /*입력하신 계좌와 지점명이 맞습니까?*/ $t("MPRS-02-02-11-05") }}</strong>
        </template>
        <template #footer>
          <button class="btn bottom negative" @click="cancel()">{{ /*아니오*/ $t("MPRS-02-02-11-06") }}</button>
          <button class="btn bottom positive" @click="confirm()">{{ /*예*/ $t("MPRS-02-02-11-07") }}</button>
        </template>
      </action-sheet>
      <action-sheet :opened.sync="mmrConfirm" :actionHeader="true" :actionFooter="true" :useTopBorder="true" title="MPRS-02-02-12-01" class="action-sheet">
        <template #content>
          <strong class="info-question nomargin-top" v-html="$t('MPRS-02-02-12-05')">
            <!-- 입금 계좌에 해당하는 지점을 찾을 수 없습니다.
            <br />계좌번호를 다시 확인해 주시기 바랍니다.-->
          </strong>
        </template>
        <template #footer>
          <button class="btn bottom positive" @click="mmrConfirm = !mmrConfirm">{{ /*확인*/ $t("MPRS-02-02-12-04") }}</button>
        </template>
      </action-sheet>
      <modal-pop :opened.sync="modalOpend" confirm="MCOM-0000003">
        <template #content>{{ $t("MPRS-02-02-12-06") }}</template>
      </modal-pop>
      <div class="btn-area--full fixed">
        <button class="btn md gray" @click="goToPrev()">{{ /*뒤로*/ $t("MPRS-02-02-15-12") }}</button>
        <button class="btn md normal" @click="goToNext()" :class="prgsYN">{{ /*다음*/ $t("MPAY-02-01-25-23") }}</button>
      </div>
    </article>
  </div>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import CommonGrid2 from "@/components/page/common/CommonGrid2";

export default {
  components: {
    CommonGrid2,
  },
  computed: {
    ...mapFields(["sessionInfo"]),
  },
  watch: {
    ovsesSendBnkRefno: function() {
      this.validPrgs();
    },
    inquryAcno: function() {
      this.validPrgs();
    },
    lcalBnkBrnEngName: function() {
      this.validPrgs();
    },
    inquryDpstrName: function() {
      this.validPrgs();
    },
    inquryAcnAls: function() {
      this.validPrgs();
    },
  },
  props: {
    usePage: {
      type: String,
    },
    cncycd: {
      type: String,
      required: true,
    },
  },
  mounted() {
    this.RBF0408W41Call();
    this.brnBnkList = this.$getBnkBrnNo().MM2.ruleSet;
  },
  data() {
    return {
      lcalBnkBrnEngNameVal: false,
      modalOpend: false,
      scrollPosition: 0,
      checkedRadioValue: "1",
      mmrConfirm: false,
      radioList: [
        {
          value: "1",
          text: "MPRS-02-02-13-03", //지점명
        },
        {
          value: "2",
          text: "MPRS-02-02-13-04", //지점번호
        },
      ],
      fillter: true,
      searchWord: "",
      openSheet: false, //sheet open
      showGrid: false, //grid open
      page: 1,
      popupShow: false, //popup open
      ovsesSendBnkRefno: "", //해외송신은행참조번호
      lcalBnkBrnEngName: "", //현지은행부점번호
      bnkEngName: "", //은행영문명
      bnkShtenName: "", //은행단축명
      lcalBnkBrnNo: "", //BO현지은행번호
      ovsesSendBnkNo: "", //해외송신은행번호
      inquryAcno: "", //계좌번호
      inquryDpstrName: "", //예금주명
      inquryAcnAls: "",
      sheetLcalBnkBrnEngName: "", //sheet에 출력되는 현지은행부점번호
      bankList: [], //은행 리스트
      RBF0408W41: {
        request: {},
        response: {},
      },
      popupRBF0408W41: {
        request: {},
        response: {},
      },
      RBF0600C60: {
        request: {},
        response: {},
      },
      searchData: {},
      mnrcvInfo: {
        mnrcvAcnAls: "",
        mnrcvAcno: "",
        mnrcvCncycd: "",
        mnrcvDpstrName: "",
        mnrcvOthrBnkName: "",
        mnrcvSerno: "",
        rcevnBnkIfscCode: "",
        mnrcvBrnName: "",
      },
      lcalBnkAcnoInfo: {},
      dataGrid: [],
      call: true,
      validList: [],
      searchType: "searchBox",
      prgsYN: "disabled",
      lcalBnkBrnEngNameYN: "",
      showLcalBnkBrnEngName: false,
      brnBnkList: [],
    };
  },
  methods: {
    validPrgs() {
      if (this.showLcalBnkBrnEngName == true) {
        if (this.lcalBnkBrnEngName == "") {
          this.lcalBnkBrnEngNameYN = true;
        } else {
          this.lcalBnkBrnEngNameYN = false;
        }
        if (this.usePage == "manage") {
          if (this.$refs.ovsesSendBnkRefno != undefined && this.$refs.inquryAcno != undefined && this.$refs.inquryDpstrName != undefined && this.$refs.inquryAcnAls != undefined) {
            this.prgsYN =
              this.$refs.ovsesSendBnkRefno.$v.$invalid ||
              this.$refs.inquryAcno.$v.$invalid ||
              this.$refs.inquryDpstrName.$v.$invalid ||
              this.$refs.inquryAcnAls.$v.$invalid ||
              this.lcalBnkBrnEngNameYN
                ? "disabled"
                : "";
            this.$EventBus.$emit("mmrRegister", this.prgsYN);
          } else {
            this.prgsYN = "";
            this.$EventBus.$emit("mmrRegister", this.prgsYN);
          }
        } else {
          if (this.$refs.ovsesSendBnkRefno != undefined && this.$refs.inquryAcno != undefined && this.$refs.inquryDpstrName != undefined) {
            this.prgsYN =
              this.$refs.ovsesSendBnkRefno.$v.$invalid || this.$refs.inquryAcno.$v.$invalid || this.$refs.inquryDpstrName.$v.$invalid || this.lcalBnkBrnEngNameYN ? "disabled" : "";
            this.$EventBus.$emit("mmrRegister", this.prgsYN);
          } else {
            this.prgsYN = "";
            this.$EventBus.$emit("mmrRegister", this.prgsYN);
          }
        }
      } else {
        if (this.usePage == "manage") {
          if (this.$refs.ovsesSendBnkRefno != undefined && this.$refs.inquryAcno != undefined && this.$refs.inquryDpstrName != undefined && this.$refs.inquryAcnAls != undefined) {
            this.prgsYN =
              this.$refs.ovsesSendBnkRefno.$v.$invalid || this.$refs.inquryAcno.$v.$invalid || this.$refs.inquryDpstrName.$v.$invalid || this.$refs.inquryAcnAls.$v.$invalid
                ? "disabled"
                : "";
            this.$EventBus.$emit("mmrRegister", this.prgsYN);
          } else {
            this.prgsYN = "";
            this.$EventBus.$emit("mmrRegister", this.prgsYN);
          }
        } else {
          if (this.$refs.ovsesSendBnkRefno != undefined && this.$refs.inquryAcno != undefined && this.$refs.inquryDpstrName != undefined) {
            this.prgsYN = this.$refs.ovsesSendBnkRefno.$v.$invalid || this.$refs.inquryAcno.$v.$invalid || this.$refs.inquryDpstrName.$v.$invalid ? "disabled" : "";
            this.$EventBus.$emit("mmrRegister", this.prgsYN);
          } else {
            this.prgsYN = "";
            this.$EventBus.$emit("mmrRegister", this.prgsYN);
          }
        }
      }
    },
    selected(text, data) {
      this.showLcalBnkBrnEngName = false;
      this.bankFullNm = text;
      this.bnkEngName = data;

      this.lcalBnkBrnEngName = "";
      this.bnkShtenName = "";
      this.ovsesSendBnkNo = "";
      this.lcalBnkBrnNo = "";
      this.inquryAcno = "";
      this.sheetLcalBnkBrnEngName = "";

      for (const data of this.brnBnkList) {
        if (data.name == this.ovsesSendBnkRefno) {
          this.showLcalBnkBrnEngName = false;
          return;
        }
      }
      this.showLcalBnkBrnEngName = true;
    },
    popupOpen() {
      this.fillter = true;
      if (this.ovsesSendBnkRefno.length == 0) {
        this.modalOpend = true;
        return;
      }

      this.lcalBnkBrnNo = this.$getBnkBrnNo().MM2.getBranchNo(this.ovsesSendBnkRefno, this.inquryAcno);
      // if (this.inquryAcno != "") {
      //   this.searchWord = this.inquryAcno.substring(0, 3);
      // }
      this.searchData = {
        brncoBnkName: this.bnkEngName, //은행영문명
        brncoLcalBnkNo: this.ovsesSendBnkRefno, //현지은행부점번호
        tranDstCd: "BRN", //은행명 조회시 'BNK' , 지점명 조회시 'BRN'
        // cctBrncdNo: this.searchWord,
      };
      if (this.ovsesSendBnkRefno.length > 0) {
        this.popupRBF0408W41Call();
      }
      if (!this.lcalBnkBrnNo.length > 0) {
        this.popupShow = true;
        this.showGrid = true;
        this.searchWord = "";
      }
    },
    popupClose(data) {
      if (data != null) {
        this.lcalBnkAcnoInfo = {
          brnAreaName: data.brnAreaName,
          brncoBnkName: data.brncoBnkName,
          brncoBrnName: data.brncoBrnName,
          brncoLcalBnkNo: data.brncoLcalBnkNo,
          cctBrncdNo: data.cctBrncdNo,
          inquryAcno: this.inquryAcno,
        };
        this.sheetLcalBnkBrnEngName = data.brncoBnkName;
        this.lcalBnkBrnEngName = data.brncoBrnName;
      }
      this.searchWord = "";
      this.popupShow = false;
      this.showGrid = false;
    },
    confirm() {
      if (this.showLcalBnkBrnEngName == false) {
        this.lcalBnkAcnoInfo = {
          ovsesSendBnkNo: this.popupRBF0408W41.response.grid[0].ovsesSendBnkNo,
          ovsesSendBnkRefno: this.popupRBF0408W41.response.grid[0].ovsesSendBnkRefno,
          bnkShtenName: this.popupRBF0408W41.response.grid[0].bnkShtenName,
          bnkEngName: this.popupRBF0408W41.response.grid[0].bnkEngName,
          lcalBnkBrnNo: this.popupRBF0408W41.response.grid[0].lcalBnkBrnNo,
          lcalBnkBrnEngName: this.popupRBF0408W41.response.grid[0].lcalBnkBrnEngName,
          inquryAcno: this.inquryAcno,
        };
        this.lcalBnkBrnEngName = this.popupRBF0408W41.response.grid[0].lcalBnkBrnEngName;
      }
      this.RBF0600C60Call();
      this.openSheet = !this.openSheet;
    },
    cancel() {
      this.lcalBnkAcnoInfo = {
        ovsesSendBnkNo: "",
        ovsesSendBnkRefno: "",
        inquryAcno: this.inquryAcno,
      };
      this.lcalBnkBrnEngName = "";
      this.openSheet = !this.openSheet;
    },

    popupRBF0408W41Call(type) {
      if (this.call) {
        if (type == "tag" || type == "addSearch") {
          this.searchType = type;
          this.page = 1;
        } else if (type == "scroll") {
          this.searchType = type;
          this.page++;
        } else {
          this.searchType = "searchBox";
          this.page = 1;
        }
        this.call = false;
        //this.page = 1;
        this.popupRBF0408W41.request = {
          dmndPageGroupNo: this.page, //요청페이지번호(입력부)
          pageCntPerPageGroup: 1,
          lineCntPerPage: "1000", //페이지라인수(입력부)
          chnlDtalsBzwkDstcd: "43", //비대면채널구분코드(40:인터넷뱅킹 / 43:스타뱅킹)
          ...this.searchData,
        };

        this.$post("/customer/acn/CbmnetBankLinstInq", this.popupRBF0408W41.request, this.popupRBF0408W41Suc, null, this.popupRBF0408W41Fin);
      }
    },
    otrbnkRBF0408W40Call() {
      this.popupRBF0408W41.request = {
        dmndPageGroupNo: this.page, //요청페이지번호(입력부)
        pageCntPerPageGroup: 1,
        lineCntPerPage: "1000", //페이지라인수(입력부)
        chnlDtalsBzwkDstcd: "43", //비대면채널구분코드(40:인터넷뱅킹 / 43:스타뱅킹)
        ...this.searchData,
      };

      return new Promise(resolve => {
        this.$post("/customer/acn/CbmnetBankLinstInq", this.popupRBF0408W41.request, response => {
          this.popupRBF0408W41.response = response.outItem;
          if (_.isEmpty(this.popupRBF0408W41.response.grid)) {
            this.lcalBnkAcnoInfo.ovsesSendBnkNo = "";
          } else if (!this.showLcalBnkBrnEngName) {
            this.lcalBnkBrnNo = this.popupRBF0408W41.response.grid[0].lcalBnkBrnNo;
            this.sheetLcalBnkBrnEngName = this.popupRBF0408W41.response.grid[0].lcalBnkBrnEngName;
            this.lcalBnkAcnoInfo.ovsesSendBnkNo = this.popupRBF0408W41.response.grid[0].ovsesSendBnkNo;
            this.lcalBnkBrnEngName = this.popupRBF0408W41.response.grid[0].lcalBnkBrnEngName;
          }
          if (_.isEmpty(this.popupRBF0408W41.response.grid)) {
            resolve(this.popupRBF0408W41.response);
          } else {
            resolve(this.popupRBF0408W41.response.grid[0].lcalBnkBrnNo);
          }
        });
      });
    },
    popupRBF0408W41Suc(res) {
      if (this.searchWord == "") {
        this.popupRBF0408W41.response = res.outItem;
        if (_.isEmpty(this.popupRBF0408W41.response.grid)) {
          this.mmrConfirm = true;
        } else {
          if (this.popupRBF0408W41.response.grid.length > 1) {
            this.dataGrid = [];
            this.dataGrid = this.popupRBF0408W41.response.grid;
            // this.$refs.commonGrid.changeList(this.popupRBF0408W41.response.grid);
            this.$refs.commonGrid2.changeList(this.dataGrid, this.popupRBF0408W41.response.totalInquryCnt, this.searchType);
          } else {
            if (this.lcalBnkBrnNo == "" || this.lcalBnkBrnNo == null) {
              this.dataGrid = [];
              this.dataGrid = this.popupRBF0408W41.response.grid;
              //this.$refs.commonGrid.changeList(this.popupRBF0408W41.response.grid);
              this.$refs.commonGrid2.changeList(this.dataGrid, this.popupRBF0408W41.response.totalInquryCnt, this.searchType);
            } else {
              this.lcalBnkBrnNo = this.popupRBF0408W41.response.grid[0].lcalBnkBrnNo;
              this.sheetLcalBnkBrnEngName = this.popupRBF0408W41.response.grid[0].lcalBnkBrnEngName;
              this.openSheet = true;
            }
          }
        }
      } else {
        this.popupRBF0408W41.response = res.outItem;
        this.dataGrid = [];
        this.dataGrid = this.popupRBF0408W41.response.grid;
        this.$refs.commonGrid2.changeList(this.dataGrid, this.popupRBF0408W41.response.totalInquryCnt, this.searchType);
        //this.$refs.commonGrid.changeList(this.popupRBF0408W41.response.grid);
      }
    },
    popupRBF0408W41Fin() {
      this.call = true;
    },
    search() {
      this.fillter = false;
      if (this.checkedRadioValue == "1") {
        this.searchData = {
          cctBrncdNo: "",
          brncoLcalBnkNo: this.ovsesSendBnkRefno, //해외송신은행참조번호
          brncoBnkName: this.bnkEngName, //은행영문명
          brncoBrnName: this.searchWord, //BO부점명
          tranDstCd: "BRN",
        };
      } else {
        this.searchData = {
          cctBrncdNo: this.searchWord,
          brncoLcalBnkNo: this.ovsesSendBnkRefno, //해외송신은행참조번호
          brncoBnkName: this.bnkEngName, //은행영문명
          brncoBrnName: "", //BO부점명
          tranDstCd: "BRN",
        };
      }
      this.popupRBF0408W41Call("searchBox");
    },
    async setInfo() {
      // if (this.usePage != "manage") {
      //   this.fillter = true;

      //   this.lcalBnkBrnNo = this.$getBnkBrnNo().MM2.getBranchNo(this.ovsesSendBnkRefno, this.inquryAcno);

      //   this.searchData = {
      //     ovsesSendBnkRefno: this.ovsesSendBnkRefno, //해외송신은행참조번호
      //     bnkEngName: this.bnkEngName, //은행영문명
      //     lcalBnkBrnNo: this.lcalBnkBrnNo, //현지은행부점번호
      //     tranDstCd: "BRN",
      //   };
      //   let res = [];
      //   if (this.ovsesSendBnkRefno.length > 0) {
      //     res = await this.otrbnkRBF0408W40Call();
      //   }
      //   if (!res.grid.length > 0) {
      //     this.searchWord = "";
      //   }
      // }
      this.mnrcvInfo = {
        mnrcvAcnAls: "",
        mnrcvAcno: this.inquryAcno,
        mnrcvCncycd: this.sessionInfo.userInfo.baseCncycd,
        mnrcvDpstrName: this.inquryDpstrName,
        mnrcvOthrBnkName: this.bnkEngName,
        mnrcvSerno: "",
        rcevnBnkIfscCode: this.lcalBnkAcnoInfo.brncoLcalBnkNo,
        cctBrncdNo: this.lcalBnkAcnoInfo.cctBrncdNo,
        mnrcvBrnName: this.lcalBnkBrnEngName,
      };
      return this.mnrcvInfo;
    },
    goToPrev() {
      this.$router.push({ name: "managePayeesList", params: { currentTab: 1 } });
    },
    RBF0408W41Call() {
      this.RBF0408W41.request = {
        lineCntPerPage: 1000,
        pageCntPerPageGroup: 1,
        dmndPageGroupNo: 1,
        tranDstCd: "BNK",
        chnlDtalsBzwkDstcd: "43", //비대면채널구분코드(40:인터넷뱅킹 / 43:스타뱅킹)
      };
      this.$post("/customer/acn/CbmnetBankLinstInq", this.RBF0408W41.request, this.RBF0408W41Suc);
    },
    RBF0408W41Suc(res) {
      this.RBF0408W41.response = res.outItem;
      let tempArry = [];
      for (const data of res.outItem.grid) {
        tempArry.push({ text: data.brncoLcalBnkNo + " (" + data.brncoBnkName + ")", value: data.brncoLcalBnkNo, data: data.brncoBnkName });
      }
      this.bankList = tempArry;
    },
    scrollEvent() {
      if (this.popupRBF0408W41.response.gridRowCnt < 10 && this.popupRBF0408W41.response.totalInquryCnt != 0) {
        return;
      } else if (this.page * this.popupRBF0408W41.response.gridRowCnt == this.popupRBF0408W41.response.totalInquryCnt) {
        return;
      } else {
        // this.scrollSearch();
        this.popupRBF0408W41Call("scroll");
      }
    },
    valid() {
      if (this.showLcalBnkBrnEngName == true) {
        if (this.lcalBnkBrnEngName == "") {
          this.lcalBnkBrnEngNameVal = true;
        } else {
          this.lcalBnkBrnEngNameVal = false;
        }
        if (this.usePage == "manage") {
          this.$refs.inquryAcnAls.$v.$touch();
        }
        this.$refs.inquryAcno.$v.$touch();
        this.$refs.inquryDpstrName.$v.$touch();
        this.$refs.ovsesSendBnkRefno.$v.$touch();
        if (this.usePage == "manage") {
          if (
            this.$refs.inquryAcno.$v.$invalid ||
            this.$refs.inquryAcnAls.$v.$invalid ||
            this.$refs.inquryDpstrName.$v.$invalid ||
            this.$refs.ovsesSendBnkRefno.$v.$invalid ||
            this.lcalBnkBrnEngNameVal
          ) {
            return false;
          }
          return true;
        } else {
          if (this.$refs.inquryAcno.$v.$invalid || this.$refs.inquryDpstrName.$v.$invalid || this.$refs.ovsesSendBnkRefno.$v.$invalid || this.lcalBnkBrnEngNameVal) {
            return false;
          }
          return true;
        }
      } else {
        if (this.lcalBnkBrnEngName == "") {
          this.lcalBnkBrnEngNameVal = true;
        } else {
          this.lcalBnkBrnEngNameVal = false;
        }
        if (this.usePage == "manage") {
          this.$refs.inquryAcnAls.$v.$touch();
        }
        this.$refs.inquryAcno.$v.$touch();
        this.$refs.inquryDpstrName.$v.$touch();
        this.$refs.ovsesSendBnkRefno.$v.$touch();
        if (this.usePage == "manage") {
          if (this.$refs.inquryAcno.$v.$invalid || this.$refs.inquryAcnAls.$v.$invalid || this.$refs.inquryDpstrName.$v.$invalid || this.$refs.ovsesSendBnkRefno.$v.$invalid) {
            return false;
          }
          return true;
        } else {
          if (this.$refs.inquryAcno.$v.$invalid || this.$refs.inquryDpstrName.$v.$invalid || this.$refs.ovsesSendBnkRefno.$v.$invalid) {
            return false;
          }
          return true;
        }
      }
    },
    goToNext() {
      if (this.valid()) {
        if (this.showLcalBnkBrnEngName == true) {
          // this.RBF0600C60Call();
          this.openSheet = true;
        } else {
          this.popupOpen();
        }
      }
    },
    RBF0600C60Call() {
      this.RBF0600C60.request = {
        dmndPageNo: "00000",
        pageLineCnt: "00000",
        gridRowCnt: "00001",
        inquiryUserStupAcnDstcd1: "2", // 입출금계좌구분코드2 1:출금계좌, 2:입금계좌
        deviceType: "mobile",
        inDataGrid: [
          {
            inquryUserStupAcnDstcd2: "2", // 입출금계좌구분코드2 1:출금계좌, 2:입금계좌
            inquryAcno: this.inquryAcno, // 계좌번호
            inqurySerno: "1", // 일련번호
            inquryBrncoEcrypPwd: "", // 계좌비밀번호
            inquryAcnAls: this.inquryAcnAls, // 계좌별명
            inquryDpstrName: this.inquryDpstrName, // 예금주명
            inquryOthrBnkName: this.bnkEngName, // 타은행명
            inquryBrnName: this.lcalBnkBrnEngName, // 부점명
            inquryCncycd: this.cncycd, //통화코드
            inquryPrcssDstcd: "2", // 처리구분코드 1:출금계좌등록, 2:입금계좌등록, 5:계좌번호변경, 6:계좌번호해지
            inquryObaobDstcd: "2", // 당타행구분코드 1:당행, 2:타행
            draweAcitmDstcd: "01",
            rcevnBnkIfscCode: this.lcalBnkAcnoInfo.brncoLcalBnkNo,
            brncoOtrbnkRmtancMdiaDstcd: "07", //CBM-NET2 기준으로 적용
            mnrcvBrnNo: this.lcalBnkAcnoInfo.cctBrncdNo, //입금부점코드
          },
        ],
      };

      this.$post(
        "/customer/acn/MnrcyAcnRegiRes",
        this.RBF0600C60.request, //input값 요청할데이터
        this.RBF0600C60Suc, //호출 성공시 실행하는 콜백
      );
    },
    /* API_RBF0600C60 호출 성공 */
    RBF0600C60Suc(res) {
      this.RBF0600C60.response = res.outItem;
      this.$router.push({ name: "managePayeesList", params: { currentTab: 1 } });
    },
    otrbnkNext() {},
  },
};
</script>
